import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { baseURL } from "../../../configurations/environment";
import { RequestConfig } from "../../../helpers/RequestConfig";

export const getSourcesTypesRedux = createAsyncThunk(
    "sources/getSources",
    async (trackerId) => {
        let response;
        if (trackerId) {
            response = await axios.get(
                `${baseURL}/api/get-source-types?tracker=${trackerId}`,
                RequestConfig(),
            );
        } else {
            response = await axios.get(
                `${baseURL}/api/get-source-types`,
                RequestConfig(),
            );
        }

        return response.data;
    },
);
